import { PolicyTermSearchRequestQuery } from '@lio/api-types';

export const getPolicyTermQuery = (params: PolicyTermSearchRequestQuery) => {
  const { pageLimit, pageOffset } = params;
  const query = new URLSearchParams();
  if (pageLimit) {
    query.append('pageLimit', String(pageLimit));
  }
  if (pageOffset) {
    query.append('pageOffset', String(pageOffset));
  }

  return query.toString();
};
